import { useState } from "react";
import { useNavigate } from "react-router";
import { cn } from "~/lib/utils";
import Button from "@components/atoms/Button";
import Page from "@components/layout/Page";
interface ErrorPageProps {
  errorMessage: string | React.ReactNode;
  onCtaClick?: React.MouseEventHandler<HTMLButtonElement>;
  ctaStyles?: string;
  isCtaLoading?: boolean;
  ctaText?: string;
  showReloadButton?: boolean;
  reloadText?: string;
  onReloadClick?: () => void;
  showCta?: boolean;
  title?: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
}

export default function ErrorPage({
  errorMessage,
  onCtaClick,
  ctaStyles,
  showCta = true,
  isCtaLoading = false,
  ctaText = "Close this window",
  showReloadButton = true,
  reloadText = "Reload",
  onReloadClick,
  title = "Something went wrong",
  children,
  icon,
}: ErrorPageProps) {
  const navigate = useNavigate();
  const [reloading, setReloading] = useState(false);

  console.error("Rendering error page", { errorMessage, title });

  const onReload = () => {
    setReloading(true);
    if (onReloadClick) {
      onReloadClick();
    } else {
      // Refresh the page
      navigate(0);
    }
  };

  return (
    <Page
      className="page-height-minus-header-and-footer "
      containerClassName="flex flex-col justify-center"
    >
      <div className="flex flex-col items-center justify-center mt-8 mb-8">
        {icon ?? <img src="/images/Error.png" alt="404" width={66} />}
        <h1 className="header1LargeExtraBold text-black text-center mt-8 mb-6">
          {title}
        </h1>
        {typeof errorMessage === "string" ? (
          <p className="bodyDefault text-center">{errorMessage}</p>
        ) : (
          <div className="bodyDefault text-center">{errorMessage}</div>
        )}
      </div>
      {showReloadButton && (
        <Button
          theme="black"
          text={reloadText}
          onClick={onReload}
          loading={reloading}
          loadingText="Reloading..."
        />
      )}
      {showCta && (
        <Button
          theme="white"
          textTheme="black"
          text={ctaText}
          onClick={onCtaClick}
          loading={isCtaLoading}
          className={cn("border border-black", ctaStyles)}
        />
      )}
      {children}
    </Page>
  );
}
